webpackJsonp([277668372514533],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRight = __webpack_require__(57);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	__webpack_require__(235);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntervistePage = function (_Component) {
	  _inherits(IntervistePage, _Component);
	
	  function IntervistePage() {
	    _classCallCheck(this, IntervistePage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IntervistePage.prototype.render = function render() {
	    var locale = 'it';
	
	    if (typeof window !== 'undefined') {
	      locale = window.localStorage.getItem('locale');
	    }
	
	    var interviews = this.props.data.allDatoCmsInterview.edges.map(function (edge) {
	      return edge.node;
	    }).filter(function (node) {
	      return node.locale === locale;
	    });
	
	    var linkPrefix = locale === 'it' ? '' : '/en';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Interviste | L\'architettura nel Cantone Ticino, 1945 - 1980'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Interviste wrap-narrower' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'text-primary mb-3' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.interviste' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Interviste__List' },
	          interviews.map(function (interview, index) {
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                key: index,
	                to: '' + linkPrefix + interview.fields.path,
	                className: 'Interviste__ListItem'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'Interviste__ListItem__Text with-arrow-icon' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Interviste__ListItem__Title' },
	                  interview.titolo
	                ),
	                _react2.default.createElement('div', {
	                  className: 'Interviste__ListItem__Body',
	                  dangerouslySetInnerHTML: { __html: interview.abstract }
	                }),
	                _react2.default.createElement(_arrowRight2.default, { className: 'Interviste__ListItem__ArrowIcon' })
	              ),
	              interview.video && _react2.default.createElement(
	                'div',
	                { className: 'Interviste__ListItem__Image' },
	                _react2.default.createElement('img', {
	                  className: 'img-responsive',
	                  src: interview.video.thumbnailUrl
	                })
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return IntervistePage;
	}(_react.Component);
	
	exports.default = IntervistePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-interviste-js-165a197ef005facf371a.js